/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataNodataClientPackageItemResVo } from './PageDataNodataClientPackageItemResVo';
import {
    PageDataNodataClientPackageItemResVoFromJSON,
    PageDataNodataClientPackageItemResVoFromJSONTyped,
    PageDataNodataClientPackageItemResVoToJSON,
    PageDataNodataClientPackageItemResVoToJSONTyped,
} from './PageDataNodataClientPackageItemResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataNodataClientPackageItemResVo
 */
export interface ResponsePageDataNodataClientPackageItemResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataNodataClientPackageItemResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataNodataClientPackageItemResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataNodataClientPackageItemResVo}
     * @memberof ResponsePageDataNodataClientPackageItemResVo
     */
    data?: PageDataNodataClientPackageItemResVo;
}

/**
 * Check if a given object implements the ResponsePageDataNodataClientPackageItemResVo interface.
 */
export function instanceOfResponsePageDataNodataClientPackageItemResVo(value: object): value is ResponsePageDataNodataClientPackageItemResVo {
    return true;
}

export function ResponsePageDataNodataClientPackageItemResVoFromJSON(json: any): ResponsePageDataNodataClientPackageItemResVo {
    return ResponsePageDataNodataClientPackageItemResVoFromJSONTyped(json, false);
}

export function ResponsePageDataNodataClientPackageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataNodataClientPackageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataNodataClientPackageItemResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataNodataClientPackageItemResVoToJSON(json: any): ResponsePageDataNodataClientPackageItemResVo {
    return ResponsePageDataNodataClientPackageItemResVoToJSONTyped(json, false);
}

export function ResponsePageDataNodataClientPackageItemResVoToJSONTyped(value?: ResponsePageDataNodataClientPackageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataNodataClientPackageItemResVoToJSON(value['data']),
    };
}

